module.exports = __webpack_public_path__ + "static/media/lumbering15.3a8741c2.jpg";